import { useState } from 'react';
import { goToLink, NewShowError } from '../projectData';
import { NewUserVirification } from '../new-otp-verification';
import { addUserRedem } from '../api';
import { useNavigate } from 'react-router-dom';


/**
 * OrderConfirmPopup
 * Renders a popup for confirming order redemption, handles OTP, error, and success states.
 */
const OrderConfirmPopup = ({ project_key, mobile, setShowTerms, reSendOtp, }) => {
    const navigate = useNavigate()
    const [redemError, setRedemError] = useState('');
    const [success, setSuccess] = useState(null);
    const [showOtp, setShowOtp] = useState(true);

    /**
     * handleClose
     * Closes the popup, resets states, and shows terms.
     */
    const handleClose = () => {
        setShowTerms(true);
        setShowOtp(false);
        setRedemError('');
        setSuccess(null);
    };

    /**
     * reloadPage
     * Reloads the current page.
     */
    const reloadPage = () => {
        window.location.reload();
    };

    /**
     * submitRedemption
     * Submits the redemption request and handles navigation or error display.
     */
    const submitRedemption = async () => {
        setRedemError('');
        addUserRedem({ project_key: project_key }).then((d) => {
            setShowOtp(false)
            if (Number(d.code) === 1) {
                goToLink(navigate, '/customer/redem-detail/success', { 'success': d?.data })
            } else {
                setRedemError(d.message);
            }
        })
    };

    return (

        <div className="d-flex  mt-15">
            <div className="row w-100 justify-content-center">
                {redemError && (
                    <NewShowError error={redemError} closePopup={reloadPage} />
                )}
                {!redemError && !success && showOtp && (
                    <div className="col-sm-12 col-md-8 col-lg-6">
                        <NewUserVirification
                            title="Verify Your Redemption Request"
                            returnFunction={submitRedemption}
                            mobile={mobile}
                            description={`Please enter the verification code sent to your registered mobile number (${mobile.replace(/.(?=.{4})/g, '*')}) to proceed with your redemption.`}
                            closePOup={handleClose}
                            reSendOtp={reSendOtp}
                        />
                    </div>
                )}
            </div>
        </div>

    );
};

export default OrderConfirmPopup;
